
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/map-testing/report",
      function () {
        return require("private-next-pages/map-testing/report.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/map-testing/report"])
      });
    }
  